// 文件类型枚举 资源文件类型
export const fileTypeEnum = {
  // '0': '视频',
  // '1': '图片',
  // '2': 'pdf',
  // '3': '文本'
  0: "默认",
  1: "图片",
  2: "视频",
  3: "文档",
};
// 资源类型枚举 资源类型
export const materialTypeEnum = {
  // 0:通用资源 1:专技资源 2:学时资源
  0: "通用资源",
  1: "专技资源",
  2: "学时资源",
};
// 等级枚举 等级 资源等级
export const levelEnum = {
  // 1 初级 2 中级 3 高级
  1: "初级",
  2: "中级",
  3: "高级",
};
// 专业方向
export const directionEnum = {
  1: "默认",
  2: "监控",
  3: "维保",
};
// 业务类型 biztype
export const bizTypeEnum = {
  0: "目录分类",
  1: "章节练习",
  2: "课堂练习",
  3: "结业考试",
  4: "国考训练",
  5: "模拟考试",
  6: "错题训练",
  7: "理论录播",
  8: "实操录播",
  9: "考前复习",
  10: "直播课程",
  11: "培训讲义",
  12: "实操考点",
  13: "仿真模拟",
  14: "无子层级",
  15: "暂无试题",
  16: "智能测试",
  17: "智能学习",
  18: "视频录播",
  19: "学时视频",
  20: "高频考点",
  21: "押题模考",
};
// 题型枚举 题目类型
export const questionTypeEnum = {
  1: "单选题",
  2: "多选题",
  3: "判断题",
  4: "简答题",
  5: "论述题",
  6: "写作题",
  7: "审稿编辑题",
  8: "综述题",
};

export const paymentStatusEnum = {
  0: "待缴费",
  1: "已缴费",
  2: "欠费",
  3: "已退款",
  4: "取消支付",
};
export const educationalEnum = {
  0: "小学",
  1: "初中",
  2: "高中",
  3: "专科",
  4: "本科",
  5: "本科以上",
};
export const contractStatusEnum = {
  0: "等待签字",
  1: "等待审核",
  2: "审核通过",
  3: "驳回",
  4: "无需审核",
};
export const orderTypeEnum = {
  1: "课程订单",
  2: "资源订单",
};
export const markStatusEnum = {
  1: "出勤",
  2: "事假",
  3: "病假",
  4: "迟到",
  5: "早退",
  6: "旷课",
  7: "公假",
};
export const evidenceStatusEnum = {
  0: "无需审核",
  1: "待审核",
  2: "审核通过",
  3: "审核驳回",
  4: "待上传",
};
